import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import SvgIcon from "@mui/material/SvgIcon";

function getDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/windows phone/i.test(userAgent)) {
    return "windows";
  }
  if (/android/i.test(userAgent)) {
    return "android";
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios";
  }
  // if(isIOS()) {
  //     return "ios";
  // }
  // if(isIpadOS()) {
  //     return "ios";
  // }
  return undefined;
}
const device = getDevice();

function isIOS() {
  if (/iPad|iPhone|iPod/.test(navigator.platform)) {
    return true;
  } else {
    return (
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform)
    );
  }
}

function isIpadOS() {
  return (
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform)
  );
}
let class_ios = "";
if (device === undefined) {
  if (isIOS()) {
    //alert("ios")
    class_ios = "mobile_rotate_ios";
  }
  if (isIpadOS()) {
    //alert("ios2")

    class_ios = "mobile_rotate_ios";
  }
}

const DirectionRotation = ({ deviceDirection }) => {
  return (
    <div
      className={`orientation-info mobile_rotate_ios ${class_ios} ${
        deviceDirection === "port" ? "mobile-active" : "mobile-inactive"
      }`}
    >
      <div className="mobile_rotate_inner_box">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            background:
              "transparent linear-gradient(122deg, #000000 0%, #262626 100%) 0% 0% no-repeat padding-box",
          }}
        >
          <Box sx={{ width: "100%", marginTop: "-60px" }}>
            <Box
              sx={{
                minWidth: 100,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <SvgIcon id="potrainticon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  viewBox="0 0 55.066 55.068"
                  sxtyle={{ width: "100px", height: "100px" }}
                >
                  <g id="rotate" transform="translate(0)">
                    <g
                      id="Group_3205"
                      data-name="Group 3205"
                      transform="translate(2.296 2.294)"
                    >
                      <path
                        id="Path_4"
                        data-name="Path 4"
                        d="M50.175,15.557,48.6,13.978,38.5,3.88,36.919,2.3C35.006.388,31.67.61,29.481,2.8L2.8,29.487C.611,31.673.389,35.009,2.3,36.925L15.555,50.178c1.914,1.914,5.25,1.691,7.439-.5L49.681,23c2.187-2.189,2.409-5.525.493-7.439Zm-3.38,5.273L20.828,46.8a1.928,1.928,0,0,1-2.705.181L5.5,34.355a1.924,1.924,0,0,1,.181-2.705L31.649,5.683A1.928,1.928,0,0,1,34.354,5.5l.631.631A1.924,1.924,0,0,1,34.8,8.838a1.928,1.928,0,0,0-.181,2.705l6.312,6.312a1.924,1.924,0,0,0,2.705-.181,1.928,1.928,0,0,1,2.705-.181l.631.631a1.928,1.928,0,0,1-.181,2.705Z"
                        transform="translate(-1.001 -1)"
                        fill="#545454"
                      />
                    </g>
                    <g
                      id="Group_3206"
                      data-name="Group 3206"
                      transform="translate(29.826 29.828)"
                    >
                      <path
                        id="Path_5"
                        data-name="Path 5"
                        d="M14.919,38.239a1.918,1.918,0,0,1-1.358-3.274L19.022,29.5a1.919,1.919,0,0,1,2.843.142l2.024,2.476A19.738,19.738,0,0,0,34.4,14.9,1.919,1.919,0,0,1,36.318,13h.016a1.921,1.921,0,0,1,1.9,1.934,23.594,23.594,0,0,1-23.3,23.305h-.016Z"
                        transform="translate(-12.999 -13)"
                        fill="#545454"
                      />
                    </g>
                    <g
                      id="Group_3207"
                      data-name="Group 3207"
                      transform="translate(0)"
                    >
                      <path
                        id="Path_6"
                        data-name="Path 6"
                        d="M23.321,0A1.918,1.918,0,0,1,24.68,3.274L19.219,8.735a1.921,1.921,0,0,1-2.845-.142L14.35,6.117A19.738,19.738,0,0,0,3.839,23.335a1.921,1.921,0,0,1-1.92,1.9H1.9A1.92,1.92,0,0,1,0,23.305,23.6,23.6,0,0,1,23.305,0Z"
                        transform="translate(0)"
                        fill="#545454"
                      />
                    </g>
                  </g>
                </svg>
              </SvgIcon>
            </Box>
            <Box
              sx={{
                minWidth: 100,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: 4,
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontSize: "1.22rem",
                  color: "#BDA770",
                  fontFamily: "'Bodoni Std', sans-serif",
                }}
              >
                Please rotate your device.
              </Typography>
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default DirectionRotation;
